import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { HelpLinkButton } from '../modal/helpModal/helpModal';

const DCAInstructionsAmazonAdvertising: JSX.Element = (
  <Container
    className="mb-3"
    data-testid="dca-instructions-amazon-aa-search-advertising"
  >
    <Row>
      <h3
        className="text-capitalize mt-2"
      >
        How to add an Amazon Search Advertising account
      </h3>
    </Row>
    <Row className="ps-3 pad-child-list-elements">
      <ol>
        <li>
          <b>
            Sign into Amazon Advertising (AA):
          </b>
          <ul>
            <li>
              Use a separate browser tab to sign in.
            </li>
            <li>
              Ensure the user account signing into AA&nbsp;
              <b>
                only has access to the desired AA account(s)
              </b>
              &nbsp; to be added into this Insights organization.
            </li>
            <li>
              Ensure you have Admin or Manage Integrations (EDI/API) permissions in your Amazon
              Advertising account to authorize data collection.
            </li>
          </ul>
        </li>
        <li>
          <b>
            Authorize the Account:
          </b>
          <ul>
            <li>
              Click the&nbsp;
              <span className="badge bg-black">
                Add
              </span>
              &nbsp;button below.
            </li>
            <li>
              You will be redirected to Amazon Advertising for authorization.
            </li>
          </ul>
        </li>
        <li>
          <b>
            Grant Access:
          </b>
          <ul>
            <li>
              Select the checkbox to provide Marshall Insights access.
            </li>
            <li>
              Click &quot;Allow&quot;.
            </li>
            <li>
              If you are unable to grant access, ensure you have the necessary permissions
              in AA to authorize data collection.
            </li>
          </ul>
        </li>
        <li>
          <b>
            Complete the Process:
          </b>
          <ul>
            <li>
              You will be redirected back to Marshall Insights.
            </li>
            <li>
              A success message will indicate the account has been added.
            </li>
          </ul>
        </li>
      </ol>
    </Row>
    <Row>
      <b>
        Troubleshooting:
      </b>
      <p>
        If you encounter any issues or have questions, contact
        <HelpLinkButton />
        .
      </p>
    </Row>
  </Container>
);

export default DCAInstructionsAmazonAdvertising;
